import { sdk } from '@/lib/api';
import { FetchError } from '@/lib/api/client';
import { queryKeysFactory } from '@/lib/query-key-factory';
import { HttpTypes } from '@/types';
import { IBlogPost } from '@/types/blog';
import { QueryKey, UseQueryOptions, useQuery } from '@tanstack/react-query';

const BLOG_DETAIL_QUERY_KEY = 'detailBlog' as const;

export const blogDetailQueryKeys = queryKeysFactory(BLOG_DETAIL_QUERY_KEY);

export const useBlogsDetails = (
  slug?: string,
  options?: Omit<
    UseQueryOptions<
      HttpTypes.IResponse<IBlogPost>,
      FetchError,
      HttpTypes.IResponse<IBlogPost>,
      QueryKey
    >,
    'queryFn' | 'queryKey'
  >
) => {
  const { data, ...rest } = useQuery({
    queryKey: blogDetailQueryKeys.detail(slug as string),
    queryFn: async () => sdk.site.blogsPages.detail(slug as string),
    ...options,
  });

  return { ...data, ...rest };
};

const BLOG_LIST_QUERY_KEY = 'listBlog' as const;

export const blogListQueryKeys = queryKeysFactory(BLOG_LIST_QUERY_KEY);

export const useBlogsList = (
  slug?: string,
  params?: HttpTypes.FindParams,
  options?: Omit<
    UseQueryOptions<
      HttpTypes.IResponse<HttpTypes.StoreBlogPostElementListResponse[]>,
      FetchError,
      HttpTypes.IResponse<HttpTypes.StoreBlogPostElementListResponse[]>,
      QueryKey
    >,
    'queryFn' | 'queryKey'
  >
) => {
  const { data, ...rest } = useQuery({
    queryKey: blogListQueryKeys.list({ slug, ...params }),
    queryFn: async () => sdk.site.blogsPages.list(slug as string, params),
    ...options,
  });

  return { ...data, ...rest };
};
